import cx from 'classnames'
import * as React from 'react'

import VisuallyHidden from '../visually-hidden'
import styles from './toggle.module.scss'

type Option = {
  id: string
  label: string
  value: string
  checked: boolean
}

export type Props = {
  legend: string
  name: string
  onChange: (arg0: React.ChangeEvent<HTMLInputElement>) => void
  optionLeft: Option
  optionCenter?: Option
  optionRight: Option
  className?: string
  'data-testid'?: string
}

const selectedOption = (
  optionLeft: Option,
  optionRight: Option,
  optionCenter?: Option,
): 'left' | 'right' | 'center' => {
  if (optionLeft.checked) {
    return 'left'
  }
  if (optionRight.checked) {
    return 'right'
  }
  if (optionCenter?.checked) {
    return 'center'
  }
  return 'left'
}

export default function Toggle({
  legend,
  name,
  optionLeft,
  optionCenter,
  optionRight,
  className,
  onChange,
  ...otherProps
}: Props) {
  const switchClassname = cx([
    styles.switch,
    styles[selectedOption(optionLeft, optionRight, optionCenter)],
    optionCenter ? styles['three-options'] : styles['two-options'],
  ])

  return (
    <fieldset
      {...otherProps}
      className={cx(styles['toggle-fieldset'], className)}
    >
      <VisuallyHidden is="legend">{legend}</VisuallyHidden>
      <div
        className={cx(
          styles['toggle-grid'],
          optionCenter ? styles['three-options'] : styles['two-options'],
        )}
      >
        <input
          type="radio"
          name={name}
          id={optionLeft.id}
          value={optionLeft.value}
          key={optionLeft.id}
          onChange={onChange}
          className={styles.input}
          checked={optionLeft.checked}
        />

        <label htmlFor={optionLeft.id} className={styles.label}>
          {optionLeft.label}
        </label>
        {optionCenter && (
          <>
            <input
              type="radio"
              name={name}
              id={optionCenter.id}
              value={optionCenter.value}
              key={optionCenter.id}
              onChange={onChange}
              className={styles.input}
              checked={optionCenter.checked}
            />

            <label htmlFor={optionCenter.id} className={styles.label}>
              {optionCenter.label}
            </label>
          </>
        )}

        <input
          type="radio"
          name={name}
          id={optionRight.id}
          value={optionRight.value}
          key={optionRight.id}
          checked={optionRight.checked}
          onChange={onChange}
          className={styles.input}
        />

        <label htmlFor={optionRight.id} className={styles.label}>
          {optionRight.label}
        </label>
        <div className={switchClassname} />
      </div>
    </fieldset>
  )
}
